import React from 'react';
import { observer } from 'mobx-react';
import BadgeWinner from './BadgeWinner';
import BadgeLoser from './BadgeLoser';
import Badge from './Badge';
import { ReactComponent as Heart } from 'nes.icons/icons/heart.svg';

interface TwoPhotosScoreProps {
  leftVotes: number;
  rightVotes: number;
}

const TwoPhotosScore: React.FC<TwoPhotosScoreProps> = observer(({ leftVotes, rightVotes }) => {
  const isTie = leftVotes === rightVotes;

  const leftWins = leftVotes > rightVotes;

  const LeftBadge = isTie ? Badge : leftWins ? BadgeWinner : BadgeLoser;
  const RightBadge = isTie ? Badge : leftWins ? BadgeLoser : BadgeWinner;

  const heart = <Heart className={'nes-icon is-small fill-white'} style={{ margin: '0 4px 2px 0px' }} />;

  return (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'space-around',
      }}
    >
      <LeftBadge>
        {heart}
        {`${leftVotes}`}
      </LeftBadge>
      <RightBadge>
        {heart}
        {`${rightVotes}`}
      </RightBadge>
    </div>
  );
});

export default TwoPhotosScore;
